export class Comment {
  id?: string;
  universalObjectString: string;
  commenterUserId: string;
  body: string;
  commentType?: string;
  parentCommentId?: string;
  isInternalOnly?: boolean;
  fileIds?: string[];
  createDateTime?: string;
  updatedBy?: string;
  canEditOrDelete?: boolean;

  // this property only exists at the client side
  // it is used to build the tree of comments
  comments?: Comment[];
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/models/comment.ts